import type { Tokens } from "../types/api";

// Browser equivalent of the mobile expo-secure-store token store. Tokens persist in
// localStorage so a page reload keeps the session; the backend base URL is non-secret
// config kept alongside for a single source of truth. The async shape mirrors the
// mobile store so the AuthProvider logic stays parallel.
const ACCESS_KEY = "cc_access_token";
const REFRESH_KEY = "cc_refresh_token";
const BASEURL_KEY = "cc_base_url";

function get(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function set(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable (private mode / quota) — non-fatal */
  }
}

function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* non-fatal */
  }
}

export const tokenStore = {
  async save(tokens: Tokens): Promise<void> {
    set(ACCESS_KEY, tokens.accessToken);
    set(REFRESH_KEY, tokens.refreshToken);
  },

  async load(): Promise<{ accessToken: string; refreshToken: string } | null> {
    const accessToken = get(ACCESS_KEY);
    const refreshToken = get(REFRESH_KEY);
    if (!accessToken || !refreshToken) return null;
    return { accessToken, refreshToken };
  },

  async clear(): Promise<void> {
    remove(ACCESS_KEY);
    remove(REFRESH_KEY);
  },

  async saveBaseUrl(baseUrl: string): Promise<void> {
    set(BASEURL_KEY, baseUrl);
  },

  async loadBaseUrl(): Promise<string | null> {
    return get(BASEURL_KEY);
  }
};
